export const SHOW_ERROR = 'containers/CustomErrorMessage/SHOW_ERROR';
export const HIDE_ERROR = 'containers/CustomErrorMessage/HIDE_ERROR';
export const SHOW_INFOR = 'containers/CustomErrorMessage/SHOW_INFOR';
export const HIDE_INFOR = 'containers/CustomErrorMessage/HIDE_INFOR';
export const SIMULATE_ERROR = 'containers/CustomErrorMessage/SIMULATE_ERROR';
export const CHECK_IE_BROWSER = 'containers/CustomErrorMessage/CHECK_IE_BROWSER';
export const SHOW_IE_WARNING = 'containers/CustomErrorMessage/SHOW_IE_WARNING';
export const HIDE_IE_WARNING = 'containers/CustomErrorMessage/HIDE_IE_WARNING';
